var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"alert alert-flash",class:'alert-'+_vm.level,attrs:{"role":"alert"},domProps:{"textContent":_vm._s(_vm.body)}})}
var staticRenderFns = []

export { render, staticRenderFns }